import React from 'react';
import classes from './UltraSound.module.css';
import fullScreenOnIcon from '../../../assets/icons/full-screen-on.svg';
import fullScreenOffIcon from '../../../assets/icons/full-screen-off.svg';

const UltraSoundTab: React.FC = () => {
  const [isFullScreen, setIsFullScreen] = React.useState<boolean>(false);
  return (
    <div className={classes.container}>
      <div
        className={classes.fullScreenIcon}
        onClick={() => {
          setIsFullScreen(!isFullScreen);
        }}
      >
        <img src={fullScreenOnIcon} alt={'toggle'} />
      </div>
      <iframe
        title={'DICOM Viewer'}
        src={'http://18.185.252.61/?study=1.3.6.1.4.1.29759.304660.20240119000729.1'}
        className={isFullScreen ? classes.fullScreenIframe : ''}
        width={'100%'}
        height={320}
      />
      {isFullScreen && (
        <div className={classes.closeIcon} onClick={() => setIsFullScreen(!isFullScreen)}>
          <img src={fullScreenOffIcon} alt={'toggle'} />
        </div>
      )}
    </div>
  );
};

export { UltraSoundTab };
